// extracted by mini-css-extract-plugin
module.exports = {"AssignServicesSection":"assignServices_AssignServicesSection__1qr6Z","customeTable":"assignServices_customeTable__KEFpq"};